const getCookieValue = (name) => {
    const b = document.cookie.match(`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`);
    return b ? decodeURIComponent(b.pop()) : '';
}

const chartConfig = {
    "setRange": {
      "value": "1d"
    },
    "setChartMode": {
      "value": "light"
    },
    "setChartLayoutType": {
      "value": "BASIC"
    }
};

const stockDetails = {
    "stockName": "Nifty 50",
    "stockId": "2000000011",
    "stockExchangeType": "IDX",
    "securityId": 13,
    "segmentType": "I"
};

export {
    getCookieValue,
    chartConfig,
    stockDetails,
}